/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useEffect, useState } from "react"
import { css } from "@emotion/react"
import { Container, Row, Col, Button, Modal } from "react-bootstrap"
import DesiredLimits from "./DesiredLimits"
import ApplicantInformation from "./ApplicantInformation"
import CoverageRequested from "./CoverageRequested"
import InsuredTotalAnnual from "./InsuredTotalAnnual"
import ContractingServices from "./ContractingServices"
import AnnualConstructionPercentage from "./AnnualConstructionPercentage"
import EstimatedProjectsRevenues from "./EstimatedProjectsRevenues"
import RequestedAdditionalInsureds from "./RequestedAdditionalInsureds"
import RequestedAdditionalNamedInsureds from "./RequestedAdditionalNamedInsureds"
import AdditionalQuestions from "./AdditionalQuestions"
import Warranty from "./Warranty"
import IFWStatements from "./IFWStatements"
import {
    actions,
    completeApplication,
    getApplication,
    submitApplication,
    submitRenewalApplication,
    getPriorApplication
} from "../../../data/applicationSlice"
import { useDispatch, useSelector } from "react-redux"
import ValidationAlert from "./ValidationAlert"
import { useNavigate, useLocation } from "react-router-dom"
import Loader from "../../../components/Loader"
import HelpCenterCard from "../../../components/HelpCenterCard"
import WarningModal from "../../../components/WarningModal"
import { poBoxRegex } from "../../../constant/utils"
import { allApplicationRequiredFields, otherQuestions } from "../../../constant/ValidationConstants"
import SubmissionAlert from "../../../components/SubmissionAlert"
import * as api from "../../../api/Application"

const { updateApplicationData, clearApplicationData, resetApplicationForRenewal, removeApplicationData } = actions

const componentStyle = css`
    margin-top: 80px;

    .create-application-margin {
        margin-top: 12px;
    }

    .create-application-margin h3,
    .create-application-margin p {
        color: #fff !important;
    }

    .create-application-margin h3 {
        margin-bottom: none !important;
    }

    .create-application-margin p {
        margin-top: none !important;
    }
`

const Application = ({ type }) => {
    const [showModal, setShowModal] = useState(false)
    const [retentionIssueQuestion, setRetentionIssueQuestion] = useState()
    const [retentionIssueAmount, setRetentionIssueAmount] = useState()
    const [warningMessage, setWarningMessage] = useState("")
    const [submissionMessage, setSubmissionMessage] = useState("")
    const [submitted, setSubmitted] = useState(false)
    const [validationErrors, setValidationErrors] = useState({})
    const [priorPolicy, setPriorPolicy] = useState({})
    const { application, fetchStatus, additionalInsured, additionalNamedInsureds } = useSelector(
        (state) => state.application
    )

    const { user } = useSelector((state) => state.authentication)
    const location = useLocation()
    // Determine if this is an admin operation (creation or editing)
    const isAdminOperation = type === "adminCreateApplication" || location.state?.adminEdit

    // const [validationAlert, setValidationAlert] = useState({
    //     show: false,
    //     questionNumber: []
    // })
    const navigate = useNavigate()
    const dispatch = useDispatch()
   

    useEffect(() => {
        let applicationId = location.state?.applicationId
        let renewal = location.state?.isRenewal
        
        if (applicationId) {
            dispatch(getApplication(applicationId)).then(({ payload }) => {
                if (renewal) {
                    let propsToPersist = [
                        "friendlyId",
                        "firstNamedInsuredCompany",
                        "firstNamedInsuredContact",
                        "firstNamedInsuredAddress",
                        "firstNamedInsuredCity",
                        "firstNamedInsuredState",
                        "firstNamedInsuredZipCode",
                        "limitsAndRetentions",
                        "additionalNamedInsureds",
                        "contractorPollutionLiabilityCoverageOnly",
                        "contractorPollutionLiabilityAndProfessionalLiabilityCoverage",
                        "doesTheApplicationCurrentlyHaveLiabilityCoverage",
                        "operationsPerformedOutsideOfUs"
                    ]
                    dispatch(resetApplicationForRenewal(propsToPersist))
                }
                if (payload.renewedFromId) {
                    dispatch(getPriorApplication(payload.renewedFromId)).then(({ payload }) => {
                        setPriorPolicy(payload)
                    })
                }
            })
        }

        return () => {
            dispatch(clearApplicationData())
        }
    }, [location.state?.applicationId])

    useEffect(() => {
        return () => {
            if (submitted) {
                dispatch(clearApplicationData())
            }
        }
    }, [])

    function getQuestionNumber(question) {
        let questionNumbers = {
            contractingServices: 3,
            annualConstructionValues: 4,
            estimatedProjectRevenue: 5,
            requestedAdditionalInsured: 6,
            requestedAdditionalNamedInsured: 7
        }
        if (application?.contractorPollutionLiabilityCoverageOnly) {
            questionNumbers = {
                contractingServices: 3,
                estimatedProjectRevenue: 4,
                requestedAdditionalInsured: 5,
                requestedAdditionalNamedInsured: 6
            }
        }
        return questionNumbers[question]
    }

    const validatePercentages = (errors, contractorPollutionLiabilityCoverageOnly) => {
        const hideCoverageOnlyQuestion = contractorPollutionLiabilityCoverageOnly === true
        const totals = {
            contractingServicesTotalPercentage: 0,
            companyTotalRevenuesTotalPercentage: 0,
            ...(!hideCoverageOnlyQuestion ? { annualConstructionValuesTotalPercentage: 0 } : [])
        }

        Object.entries(application).forEach(([key, value]) => {
            if (typeof value === "number" && !key.includes("Label")) {
                if (key.includes("contractingService")) {
                    totals.contractingServicesTotalPercentage += value
                } else if (key.includes("companyTotalRevenue")) {
                    totals.companyTotalRevenuesTotalPercentage += value
                } else if (key.includes("annualConstructionValue") && !hideCoverageOnlyQuestion) {
                    totals.annualConstructionValuesTotalPercentage += value
                }
            }
        })

        Object.keys(totals).forEach((key) => {
            if (totals[key] !== 100) {
                errors[key] = true
            }
        })

        return errors
    }

    const validateInsuredInfoData = () => {
        if (
            application?.firstNamedInsuredCompany &&
            application?.firstNamedInsuredCompany === `${user?.firstName} ${user?.lastName}`
        ) {
            setWarningMessage("The insured name cannot be the same as the agent name.")
            return false
        } else if (
            application?.firstNamedInsuredAddress &&
            poBoxRegex.test(application?.firstNamedInsuredAddress?.trim())
        ) {
            setWarningMessage("P.O. Box addresses are not allowed.")
            return false
        }
        return true
    }

    const validateRequiredFields = () => {
        let errors = {}

        //Checking for all the required fields.
        allApplicationRequiredFields.forEach((field) => {
            if (!application?.[field]) {
                errors[field] = true
            }
        })

        //Checking for percentages fields.
        errors = validatePercentages(errors, application?.contractorPollutionLiabilityCoverageOnly)

        // checking for coverage requested
        if (
            !application?.contractorPollutionLiabilityCoverageOnly &&
            !application?.contractorPollutionLiabilityAndProfessionalLiabilityCoverage
        ) {
            errors["coverageRequested"] = true
        }

        // checking for coverage requested "Pollution Only" and extended options

        if (application?.contractorPollutionLiabilityCoverageOnly) {
            if (![true, false].includes(application?.doesTheApplicationCurrentlyHaveLiabilityCoverage)) {
                errors["doesTheApplicationCurrentlyHaveLiabilityCoverage"] = true
            } else {
                if (application?.doesTheApplicationCurrentlyHaveLiabilityCoverage) {
                    let pollutionOnlyCoverageFields = [
                        "contractorsPollutionCoverage",
                        "nonOwnedDisposalSiteCoverage",
                        "moldCoverage"
                    ]
                    pollutionOnlyCoverageFields.forEach((field) => {
                        if (!application?.[field]) {
                            errors[field] = true
                        }
                    })

                    let pollutionOnlyRetroactiveDateFields = [
                        "contractorsPollutionCoverageRetroactiveDate",
                        "nonOwnedDisposalSiteCoverageRetroactiveDate",
                        "moldCoverageRetroactiveDate"
                    ]

                    pollutionOnlyCoverageFields.forEach((field, index) => {
                        if (application?.[field] && application?.[field].includes("RetroactiveDate")) {
                            !application?.[pollutionOnlyRetroactiveDateFields[index]] &&
                                (errors[pollutionOnlyRetroactiveDateFields[index]] = true)
                        }
                    })
                }
            }
        }

        // checking for coverage requested "Pollution and Professional Liability" and extended options

        if (application?.contractorPollutionLiabilityAndProfessionalLiabilityCoverage) {
            if (![true, false].includes(application?.doesTheApplicationCurrentlyHaveLiabilityCoverage)) {
                errors["doesTheApplicationCurrentlyHaveLiabilityCoverage"] = true
            } else {
                if (application?.doesTheApplicationCurrentlyHaveLiabilityCoverage) {
                    let pollutionAndProfessionalCoverageFields = [
                        "professionalLiabilityCoverage",
                        "contractorsPollutionCoverage",
                        "nonOwnedDisposalSiteCoverage",
                        "moldCoverage"
                    ]
                    pollutionAndProfessionalCoverageFields.forEach((field) => {
                        if (!application?.[field]) {
                            errors[field] = true
                        }
                    })

                    let pollutionAndProfessionalRetroactiveDateFields = [
                        "professionalLiabilityCoverageRetroactiveDate",
                        "contractorsPollutionCoverageRetroactiveDate",
                        "nonOwnedDisposalSiteCoverageRetroactiveDate",
                        "moldCoverageRetroactiveDate"
                    ]

                    pollutionAndProfessionalCoverageFields.forEach((field, index) => {
                        if (application?.[field] && application?.[field].includes("RetroactiveDate")) {
                            !application?.[pollutionAndProfessionalRetroactiveDateFields[index]] &&
                                (errors[pollutionAndProfessionalRetroactiveDateFields[index]] = true)
                        }
                    })
                }
            }
        }

        // checking for Desired Limits of Liability and Retention Amount
        if (application?.limitsAndRetentions) {
            application?.limitsAndRetentions.forEach((limit) => {
                if (!limit?.limits) {
                    let key = `limits-${application?.limitsAndRetentions.indexOf(limit)}`
                    errors[key] = true
                }
                if (!limit?.retention) {
                    let key = `retention-${application?.limitsAndRetentions.indexOf(limit)}`
                    errors[key] = true
                }
            })
        }

        // checking for other Questions
        otherQuestions.forEach(({ field, explanation }) => {
            if (![true, false].includes(application?.[field])) {
                errors[field] = true
            }

            if (application?.[field] === true && explanation && !application?.[explanation]) {
                errors[explanation] = true
            }
        })

        // checking for broker selection when creating on behalf of agencies
        if (isAdminOperation) {
            if (!application?.brokerageId) {
                errors.brokerageId = true
            }
            if (!application?.brokerContactId) {
                errors.brokerContactId = true
            }
        }

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors)
            return false
        }
        return true
    }

    const handleSubmit = () => {
        if (!validateRequiredFields()) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            return false
        }

        if (!validateInsuredInfoData()) {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
            return false
        }

        let payload = {
            ...application,
            additionalNamedInsureds: [
                ...(additionalNamedInsureds?.filter(
                    (additionalInsured) => additionalInsured?.relationship || additionalInsured?.name
                ) || []),
                ...(additionalInsured?.filter(
                    (additionalInsured) => additionalInsured?.relationship || additionalInsured?.name
                ) || [])
            ],
            createdOnBehalf: isAdminOperation
        }

        // Preserve original creator from the GET /Applications/{id} response
        if (application?.createdById || application?.CreatedById) {
            payload.createdById = application?.createdById || application?.CreatedById
        }

        // Map selected Broker Contact to backend submittedForId
        if (isAdminOperation && application?.brokerContactId) {
            payload.submittedForId = application.brokerContactId
        }

        let applicationId = location.state?.applicationId
        let renewal = location.state?.isRenewal
        let isEdit = location.state?.isEdit
        let adminEdit = location.state?.adminEdit

        // Handle admin editing - update existing application using POST API
        if (isEdit && adminEdit && applicationId) {
            payload.id = applicationId
            payload.status = application?.status

            dispatch(submitApplication({ ...payload })).then(({ payload: submitPayload }) => {
                if (submitPayload?.succeeded) {
                    setSubmissionMessage(`Application has been updated successfully.`)
                    setSubmitted(true)
                } else {
                    setSubmissionMessage("Error updating application. Please try again.")
                }
            })
            return
        }

        const submitAction = renewal
            ? submitRenewalApplication(applicationId, { ...payload })
            : submitApplication({ ...payload })

        dispatch(submitAction).then(({ payload: submitPayload }) => {
            if (submitPayload?.succeeded) {
                dispatch(completeApplication(submitPayload?.id)).then(({ payload: completePayload }) => {
                    if (completePayload?.succeeded) {
                        setSubmissionMessage(
                            `Thank you for submitting your application. Your current application status is: <strong>${completePayload?.status}</strong>. `
                        )
                    }
                    setSubmitted(true)
                })
            }
        })
    }

    const updateApplication = (e) => {
        const { name, type, value } = e?.currentTarget || {}

        let updatedValue

        if (type === "number") {
            updatedValue = parseFloat(value)
        } else if (type === "radio") {
            updatedValue = value === "true" ? true : value === "false" ? false : !application?.[name]
        } else {
            updatedValue = value
        }

        dispatch(
            updateApplicationData({
                field: name,
                value: updatedValue
            })
        )

        if (name === "contractorPollutionLiabilityCoverageOnly") {
            dispatch(
                updateApplicationData({
                    field: "contractorPollutionLiabilityAndProfessionalLiabilityCoverage",
                    value: false
                })
            )
        } else if (name === "contractorPollutionLiabilityAndProfessionalLiabilityCoverage") {
            dispatch(
                updateApplicationData({
                    field: "contractorPollutionLiabilityCoverageOnly",
                    value: false
                })
            )
        }

        // removing validation error of Coverage Requested
        if (
            name === "contractorPollutionLiabilityCoverageOnly" ||
            name === "contractorPollutionLiabilityAndProfessionalLiabilityCoverage"
        ) {
            validationErrors["coverageRequested"] &&
                setValidationErrors((preErrors) => ({ ...preErrors, coverageRequested: "" }))
        }
        validationErrors[name] && setValidationErrors((preErrors) => ({ ...preErrors, [name]: "" }))

        // Handle  retroactive date and remove unnecessary key
        if (
            name === "professionalLiabilityCoverage" &&
            value !== "CurrentProfessionalLiabilityCoverageRetroactiveDate"
        ) {
            dispatch(removeApplicationData("professionalLiabilityCoverageRetroactiveDate"))
        }

        if (name === "contractorsPollutionCoverage" && value !== "CurrentContractorsPollutionCoverageRetroactiveDate") {
            dispatch(removeApplicationData("contractorsPollutionCoverageRetroactiveDate"))
        }

        if (name === "nonOwnedDisposalSiteCoverage" && value !== "CurrentNonOwnedDisposalSiteCoverageRetroactiveDate") {
            dispatch(removeApplicationData("nonOwnedDisposalSiteCoverageRetroactiveDate"))
        }

        if (name === "moldCoverage" && value !== "CurrentMoldCoverageRetroactiveDate") {
            dispatch(removeApplicationData("moldCoverageRetroactiveDate"))
        }
    }

    // Function to confirm and close the modal
    const handleConfirm = () => {
        setShowModal(false)
        navigate("/agency/dashboard")
    }

    const handleCloseWarningModal = () => {
        setWarningMessage("")
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        }, 500)
    }
    return (
        <div
            css={componentStyle}
            className="mb-4 page-container">
            <WarningModal
                show={warningMessage !== ""}
                handleClose={handleCloseWarningModal}
                message={warningMessage}
            />
            <SubmissionAlert
                show={submissionMessage !== ""}
                handleClose={() => {
                    setSubmissionMessage("")
                    navigate(-1) // Go to pervious page
                }}
                message={submissionMessage}
                title="Submission Alert"
            />
            <Loader show={fetchStatus === "loading"} />
            <Container
                fluid
                className="d-flex flex-row justify-content-center pt-6">
                <HelpCenterCard />
            </Container>
            {/* {validationAlert.show && (
                <ValidationAlert
                    show={validationAlert}
                    setShow={() =>
                        setValidationAlert({
                            show: false,
                            questionNumber: []
                        })
                    }
                    questionNumber={validationAlert.questionNumber}
                />
            )} */}
            <div className="create-application-margin">
                <Row>
                    <Col>
                        <h3 className="text-center">Contractor Pollution and Professional Liability Application</h3>
                        {isAdminOperation && (
                            <p className="fs-6 text-center">
                                This form must be dated and signed by a principal of your Company. Answer all questions
                                completely. Please provide supporting information on a separate sheet and reference the
                                applicable question number. Any supporting information is considered part of this
                                application and is subject to the same terms and conditions.
                            </p>
                        )}
                    </Col>
                </Row>
            </div>

            <div className="bg-white p-3 mt-1">
                <fieldset className="fieldset mt-4">
                    <legend className="fieldsetLegend">Applicant Information</legend>
                    <ApplicantInformation
                        applicationData={application}
                        updateApplication={updateApplication}
                        validationError={validationErrors}
                        type={isAdminOperation ? "adminCreateApplication" : type}
                    />
                </fieldset>

                <fieldset className="fieldset mt-4">
                    <legend className="fieldsetLegend">Coverage Requested</legend>
                    <CoverageRequested
                        applicationData={application}
                        priorPolicy={priorPolicy}
                        isRenewal={location.state?.isRenewal}
                        updateApplication={updateApplication}
                        validationError={validationErrors}
                    />
                </fieldset>

                <fieldset className="fieldset mt-4">
                    <legend className="fieldsetLegend">Questions</legend>
                    <DesiredLimits
                        applicationData={application}
                        validationError={validationErrors}
                        setValidationErrors={setValidationErrors}
                    />
                    <InsuredTotalAnnual
                        applicationData={application}
                        updateApplication={updateApplication}
                        validationError={validationErrors}
                    />
                    <ContractingServices
                        questionNumber={getQuestionNumber("contractingServices")}
                        validationError={validationErrors}
                        setValidationErrors={setValidationErrors}
                    />
                    {!application?.contractorPollutionLiabilityCoverageOnly ? (
                        <AnnualConstructionPercentage
                            questionNumber={getQuestionNumber("annualConstructionValues")}
                            validationError={validationErrors}
                            setValidationErrors={setValidationErrors}
                        />
                    ) : null}
                    <EstimatedProjectsRevenues
                        questionNumber={getQuestionNumber("estimatedProjectRevenue")}
                        validationError={validationErrors}
                        setValidationErrors={setValidationErrors}
                    />
                    <RequestedAdditionalInsureds
                        questionNumber={getQuestionNumber("requestedAdditionalInsured")}
                        validationError={validationErrors}
                        setValidationErrors={setValidationErrors}
                    />
                    <RequestedAdditionalNamedInsureds
                        questionNumber={getQuestionNumber("requestedAdditionalNamedInsured")}
                    />
                    <br />
                    <AdditionalQuestions
                        validationError={validationErrors}
                        setValidationErrors={setValidationErrors}
                    />
                </fieldset>
                <br />
                <div className="bold-mid-text">
                    Please complete warranty, authorized signature and continuing duty to update on following page.
                </div>
                <br />
                <fieldset className="fieldset">
                    <legend className="fieldsetLegend">
                        Warranty, Authorized Signature and Continuing Duty To Update
                    </legend>
                    <Warranty />
                </fieldset>
                <br />
                <div className="bold-mid-text">
                    This Statement is provided to you with the insurance application or claim form that you are filing.
                    READ the applicable Fraud Warning Statement for the state in which your claim or application is
                    being made before executing and submitting the attached document to the Insurer or your agent.{" "}
                </div>
                <br />
                <fieldset className="fieldset">
                    <legend className="fieldsetLegend">Insurance Fraud Warning Statement</legend>
                    <IFWStatements />
                </fieldset>
                <br />
                <div className="d-flex justify-content-end">
                    <Button
                        className="btn-sm"
                        variant="primary"
                        type="submit"
                        onClick={handleSubmit}>
                        Submit Application
                    </Button>

                    {/* Modal for confirmation */}
                    <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Retention Amount Adjustment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {`Based on your answer to question ${retentionIssueQuestion}, the retention amount has been adjusted to $${retentionIssueAmount?.toLocaleString()}.`}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                size="sm"
                                variant="primary"
                                onClick={() => setShowModal(false)}>
                                Cancel
                            </Button>
                            <Button
                                size="sm"
                                variant="secondary"
                                onClick={handleConfirm}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
                {Object.keys(validationErrors).length > 0 && (
                    <div className="text-danger ml-2 d-flex justify-content-end">Please fill all required fields</div>
                )}
            </div>
        </div>
    )
}

export default Application
